export const cart = {
  en: {
    orderSummary: "Order summary",
    subtotal: "Subtotal",
    shipping: "Shipping",
    free: "Free",
    tax: "Tax",
    estTax: "est. Tax",
    estTaxTooltip: "Final taxes will be calculated during order placement.",
    estTaxTooltipAria: "More information about estimated tax",
    donation: "Donation",
    discount: "Discount",
    giftCard: "Gift Card",
    total: "Total",
    // Plural: item count in cart badges / summaries.
    itemCount: {
      one: "{count} item",
      other: "{count} items",
    },
    // Cart button aria-label content when the cart is empty.
    empty: "empty",
    // Plural: "{count} item(s) total" fragment in the cart button live region.
    itemCountTotal: {
      one: "{count} item total",
      other: "{count} items total",
    },
    // {total} = the pre-built "{count} item(s) total" fragment above.
    addedToCartAnnouncement: "Added to cart. {total}.",
    removedFromCartAnnouncement: "Removed from cart. {total}.",
  },
  de: {
    orderSummary: "Bestellübersicht",
    subtotal: "Zwischensumme",
    shipping: "Versand",
    free: "Kostenlos",
    tax: "Steuer",
    estTax: "geschätzte Steuer",
    estTaxTooltip: "Die endgültige Steuer wird bei der Bestellung berechnet.",
    estTaxTooltipAria: "Mehr Informationen zur geschätzten Steuer",
    donation: "Spende",
    discount: "Rabatt",
    giftCard: "Geschenkkarte",
    total: "Gesamt",
    itemCount: {
      one: "{count} Artikel",
      other: "{count} Artikel",
    },
    empty: "leer",
    itemCountTotal: {
      one: "{count} Artikel insgesamt",
      other: "{count} Artikel insgesamt",
    },
    addedToCartAnnouncement: "Zum Warenkorb hinzugefügt. {total}.",
    removedFromCartAnnouncement: "Aus dem Warenkorb entfernt. {total}.",
  },
} as const
